import * as React from 'react';
import styled from 'styled-components';

import { TaskDetailGrid } from '@process-advisor/process-miner/model/tasks/taskDetailGrid';
import { getShadow, getZIndex } from '@process-advisor/process-miner/shared/theme';

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${getShadow('pane')};
    z-index: ${getZIndex('panel')};
    padding-bottom: 5px;
`;


export const TaskDetail = () => {
    return (
        <Wrapper>
            <TaskDetailGrid/>
        </Wrapper>

    );
};
